export { IllustrationGame } from './illustration-game';
